<template>
    <div class="page_index">
        <div v-if="subTitle" class="page_unit">{{ subTitle }}</div>
        <div class="flex flex_center">
            <div>
                <!-- <img :src="imgLeftList" alt=""> -->
                <span>&gt;</span>
            </div>
            <div>{{ title }}</div>
            <div>
                <!-- <img :src="imgRightList" alt=""> -->
                <span>&lt;</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'itemTitle',
    props: {
        subTitle: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: '标题'
        },
        imgLeftList: {
            type: String,
            default: require("@/assets/images/icon_left.png")
        },
        imgRightList: {
            type: String,
            default: require("@/assets/images/icon_right.png")
        }

    },
    data() {
        return {}
    },
    components: {},
    created() { },
    computed: {},
    watch: {},
    methods: {}
}
</script>

<style lang='scss' scoped>
.page_index {
    @include font(28, #A84E14, center);
    font-weight: bold;
    margin-bottom: vh(26);
    padding-top: vh(20);

    img {
        width: vh(10);
        height: vh(18);
        margin: 0 vh(20);
    }

    .page_unit {
        height: vh(25);
        @include font(18, #A84E14, right);
        margin-right: vh(30);
        font-weight: 100;
    }
}
</style>